export const itemPowerChartData: Record<string, { line: number[]; bar: number[] }> = {
  ITM001: {
    line: [
      0.59, 1.37, 1.16, 0.56, 0.9, 1.04, 0.86, 0.56, 1.42, 1.3, 0.57, 1.46, 1.41, 1.27, 1.29, 1.44,
      1.31, 0.75, 0.71, 1.16, 0.91, 1.23, 1.43, 0.85,
    ],
    bar: [
      28.32, 93.16, 63.8, 27.44, 52.2, 61.36, 42.14, 28.0, 96.56, 71.5, 33.06, 83.22, 71.91, 69.85,
      78.69, 67.68, 68.12, 42.0, 46.15, 78.88, 50.05, 62.73, 87.23, 36.55,
    ],
  },
  ITM002: {
    line: [
      1.2, 1.06, 0.83, 1.3, 1.4, 1.44, 0.66, 1.49, 1.09, 0.98, 0.89, 0.94, 1.44, 0.7, 1.24, 0.85,
      1.42, 1.08, 1.25, 1.12, 1.23, 0.51, 1.08, 1.46,
    ],
    bar: [
      57.6, 55.12, 57.27, 78.0, 98.0, 72.0, 33.66, 87.91, 53.41, 46.06, 40.05, 63.92, 100.8, 42.0,
      68.2, 41.65, 69.58, 65.88, 70.0, 44.8, 66.42, 32.64, 69.12, 77.38,
    ],
  },
  ITM003: {
    line: [
      1.3, 1.25, 1.0, 0.79, 1.3, 1.28, 0.51, 1.47, 0.55, 0.87, 0.65, 1.39, 0.62, 1.38, 0.81, 1.23,
      0.99, 1.48, 0.88, 1.32, 0.79, 0.77, 0.83, 0.76,
    ],
    bar: [
      61.1, 87.5, 67.0, 37.13, 67.6, 79.36, 32.13, 64.68, 29.15, 48.72, 42.25, 84.79, 39.06, 89.7,
      38.07, 82.41, 58.41, 85.84, 50.16, 77.88, 33.18, 40.81, 35.69, 43.32,
    ],
  },
  ITM004: {
    line: [
      1.01, 1.04, 0.62, 1.48, 1.14, 0.79, 0.55, 0.69, 0.83, 0.74, 1.31, 1.07, 1.06, 0.7, 0.63, 0.89,
      0.95, 1.29, 0.91, 1.35, 0.95, 1.46, 1.25, 0.64,
    ],
    bar: [
      52.52, 67.6, 34.1, 79.92, 61.56, 46.61, 25.3, 37.95, 45.65, 44.4, 53.71, 56.71, 51.94, 33.6,
      27.09, 36.49, 52.25, 67.08, 41.86, 68.85, 56.05, 96.36, 73.75, 41.6,
    ],
  },
  ITM005: {
    line: [
      1.4, 0.53, 0.62, 0.83, 0.88, 0.59, 0.71, 0.81, 1.17, 0.87, 0.71, 1.01, 0.55, 0.99, 1.25, 1.42,
      0.58, 0.61, 1.19, 1.16, 1.44, 1.16, 1.36, 1.15,
    ],
    bar: [
      63.0, 33.39, 35.96, 34.86, 56.32, 37.76, 34.08, 34.02, 73.71, 59.16, 29.11, 70.7, 26.95,
      45.54, 56.25, 61.06, 34.22, 37.21, 74.97, 60.32, 67.68, 77.72, 61.2, 74.75,
    ],
  },
  ITM006: {
    line: [
      0.8, 0.8, 1.05, 1.12, 1.09, 0.83, 0.51, 1.18, 1.33, 0.83, 1.32, 0.78, 0.74, 0.95, 1.09, 0.92,
      1.28, 0.61, 0.58, 1.35, 1.49, 0.86, 1.18, 1.24,
    ],
    bar: [
      38.4, 46.4, 59.85, 56.0, 52.32, 58.1, 22.95, 77.88, 54.53, 51.46, 88.44, 45.24, 34.04, 46.55,
      51.23, 57.04, 67.84, 40.26, 40.02, 67.5, 59.6, 53.32, 75.52, 78.12,
    ],
  },
  ITM007: {
    line: [
      0.99, 1.29, 1.35, 0.89, 0.95, 1.29, 1.1, 0.82, 0.98, 0.74, 0.71, 1.14, 1.34, 0.55, 0.64, 0.64,
      0.77, 1.15, 1.16, 0.56, 0.7, 0.68, 0.64, 1.39,
    ],
    bar: [
      56.43, 69.66, 56.7, 45.39, 41.8, 76.11, 51.7, 57.4, 64.68, 44.4, 32.66, 45.6, 65.66, 29.15,
      35.84, 26.24, 32.34, 67.85, 78.88, 23.52, 42.0, 29.24, 43.52, 77.84,
    ],
  },
  ITM008: {
    line: [
      1.08, 0.72, 1.13, 1.1, 0.89, 0.88, 0.54, 1.26, 0.73, 1.41, 1.21, 1.39, 1.47, 0.68, 1.31, 1.04,
      1.33, 1.22, 1.34, 1.02, 0.58, 1.17, 1.37, 0.83,
    ],
    bar: [
      73.44, 34.56, 72.32, 70.4, 40.94, 48.4, 22.14, 81.9, 37.96, 71.91, 64.13, 58.38, 73.5, 32.64,
      62.88, 58.24, 87.78, 70.76, 80.4, 70.38, 37.12, 46.8, 69.87, 49.8,
    ],
  },
  ITM009: {
    line: [
      1.18, 0.98, 0.66, 1.38, 0.88, 1.15, 0.86, 1.22, 0.5, 0.69, 0.84, 1.36, 1.33, 1.12, 1.12, 0.79,
      1.44, 1.47, 1.0, 1.4, 1.06, 0.52, 0.62, 1.36,
    ],
    bar: [
      63.72, 56.84, 43.56, 74.52, 36.08, 80.5, 57.62, 59.78, 25.0, 33.12, 57.12, 58.48, 66.5, 49.28,
      44.8, 39.5, 63.36, 101.43, 47.0, 78.4, 59.36, 34.84, 34.72, 89.76,
    ],
  },
  ITM010: {
    line: [
      1.13, 1.34, 0.62, 1.33, 1.09, 1.23, 1.32, 1.1, 0.68, 1.06, 1.17, 1.39, 1.28, 1.14, 0.84, 0.58,
      0.76, 0.67, 0.86, 0.71, 1.19, 0.95, 0.59, 0.76,
    ],
    bar: [
      53.11, 75.04, 35.96, 73.15, 46.87, 65.19, 56.76, 64.9, 29.92, 55.12, 81.9, 79.23, 62.72, 57.0,
      46.2, 23.78, 49.4, 26.8, 37.84, 46.15, 49.98, 66.5, 28.91, 34.96,
    ],
  },
  ITM011: {
    line: [
      1.36, 1.43, 1.45, 0.8, 0.63, 0.64, 1.29, 1.36, 0.77, 1.19, 0.92, 0.59, 0.84, 1.17, 1.29, 1.19,
      1.19, 1.31, 1.32, 1.39, 1.24, 0.63, 1.16, 0.51,
    ],
    bar: [
      61.2, 78.65, 89.9, 44.8, 40.95, 44.8, 89.01, 65.28, 43.89, 70.21, 49.68, 25.37, 44.52, 81.9,
      54.18, 65.45, 51.17, 82.53, 81.84, 91.74, 74.4, 27.72, 80.04, 26.01,
    ],
  },
  ITM012: {
    line: [
      1.38, 1.28, 1.38, 1.48, 0.64, 1.17, 1.43, 1.0, 0.76, 0.67, 1.43, 1.17, 1.16, 1.31, 1.26, 0.78,
      0.91, 0.65, 1.29, 1.24, 0.95, 1.43, 0.84, 0.59,
    ],
    bar: [
      57.96, 87.04, 57.96, 65.12, 32.64, 64.35, 77.22, 63.0, 40.28, 42.88, 75.79, 79.56, 73.08,
      55.02, 57.96, 37.44, 62.79, 33.8, 90.3, 76.88, 42.75, 75.79, 54.6, 40.71,
    ],
  },
  ITM013: {
    line: [
      1.11, 0.52, 0.82, 1.41, 0.88, 0.92, 1.43, 1.41, 0.67, 1.4, 0.61, 0.85, 0.57, 1.12, 0.54, 0.85,
      0.51, 0.87, 0.53, 0.88, 1.24, 0.88, 0.83, 1.03,
    ],
    bar: [
      63.27, 28.08, 54.12, 84.6, 44.0, 59.8, 67.21, 95.88, 40.2, 84.0, 27.45, 34.0, 35.34, 76.16,
      27.0, 43.35, 20.91, 34.8, 33.39, 51.04, 50.84, 47.52, 39.01, 52.53,
    ],
  },
  ITM014: {
    line: [
      0.6, 0.59, 0.57, 1.25, 0.55, 1.13, 0.64, 1.15, 0.98, 0.58, 0.88, 0.55, 0.61, 1.07, 1.47, 0.52,
      0.84, 0.59, 1.07, 1.42, 1.49, 0.98, 0.63, 1.11,
    ],
    bar: [
      25.8, 41.3, 33.06, 62.5, 29.15, 70.06, 25.6, 51.75, 48.02, 29.58, 57.2, 35.2, 28.67, 65.27,
      61.74, 25.48, 43.68, 24.78, 64.2, 85.2, 59.6, 49.98, 26.46, 44.4,
    ],
  },
  ITM015: {
    line: [
      1.38, 0.88, 1.21, 0.65, 1.31, 0.6, 0.9, 1.38, 0.96, 0.98, 0.92, 0.66, 0.95, 1.23, 0.82, 0.59,
      0.5, 0.73, 1.17, 0.79, 0.73, 1.45, 0.83, 1.4,
    ],
    bar: [
      63.48, 57.2, 81.07, 40.95, 86.46, 35.4, 57.6, 95.22, 65.28, 67.62, 42.32, 44.88, 47.5, 59.04,
      46.74, 37.76, 24.5, 49.64, 51.48, 55.3, 30.66, 91.35, 38.18, 93.8,
    ],
  },
  ITM016: {
    line: [
      0.85, 0.81, 0.75, 1.33, 1.03, 0.81, 1.36, 1.05, 0.53, 0.69, 1.34, 0.92, 1.29, 1.49, 1.38,
      0.99, 0.71, 1.29, 0.82, 1.41, 0.83, 0.82, 1.34, 0.56,
    ],
    bar: [
      45.05, 37.26, 46.5, 67.83, 42.23, 37.26, 73.44, 44.1, 30.21, 28.29, 58.96, 44.16, 72.24,
      99.83, 78.66, 47.52, 28.4, 86.43, 32.8, 86.01, 34.86, 57.4, 56.28, 29.68,
    ],
  },
  ITM017: {
    line: [
      0.67, 0.57, 0.76, 0.66, 0.86, 1.09, 0.67, 1.35, 0.52, 0.64, 1.27, 1.11, 1.35, 1.05, 1.39,
      1.37, 1.26, 1.22, 0.57, 1.03, 1.26, 1.21, 0.62, 1.31,
    ],
    bar: [
      43.55, 39.33, 53.2, 27.72, 43.86, 63.22, 34.17, 79.65, 28.6, 37.12, 52.07, 47.73, 82.35, 50.4,
      56.99, 57.54, 78.12, 48.8, 26.22, 62.83, 55.44, 50.82, 39.68, 77.29,
    ],
  },
  ITM018: {
    line: [
      0.92, 1.05, 1.36, 0.92, 1.11, 0.67, 1.36, 0.88, 1.23, 1.18, 0.64, 1.33, 0.74, 1.11, 0.89,
      1.11, 1.49, 1.0, 0.53, 0.64, 1.45, 1.43, 0.72, 1.25,
    ],
    bar: [
      55.2, 67.2, 70.72, 55.2, 66.6, 35.51, 63.92, 49.28, 56.58, 55.46, 32.0, 58.52, 40.7, 62.16,
      45.39, 76.59, 87.91, 62.0, 31.8, 26.88, 65.25, 70.07, 34.56, 86.25,
    ],
  },
  ITM019: {
    line: [
      1.21, 1.1, 0.9, 0.84, 0.98, 1.48, 0.61, 0.91, 1.14, 1.25, 0.8, 0.82, 1.34, 0.81, 0.77, 1.23,
      1.08, 1.4, 0.69, 1.32, 1.37, 1.31, 1.24, 1.2,
    ],
    bar: [
      48.4, 61.6, 36.0, 51.24, 51.94, 74.0, 27.45, 51.87, 64.98, 68.75, 34.4, 52.48, 53.6, 48.6,
      41.58, 77.49, 51.84, 74.2, 34.5, 69.96, 94.53, 83.84, 57.04, 49.2,
    ],
  },
  ITM020: {
    line: [
      0.54, 1.25, 1.0, 1.32, 1.4, 1.42, 0.57, 0.95, 0.61, 0.81, 0.57, 1.39, 0.84, 1.38, 0.71, 0.93,
      1.12, 1.35, 0.96, 1.38, 0.74, 0.78, 1.17, 0.83,
    ],
    bar: [
      34.56, 82.5, 67.0, 84.48, 70.0, 65.32, 37.05, 43.7, 42.7, 40.5, 23.37, 59.77, 53.76, 91.08,
      41.89, 62.31, 77.28, 67.5, 62.4, 96.6, 38.48, 48.36, 58.5, 46.48,
    ],
  },
};
